module.exports = __webpack_public_path__ + "img/S1051445.31a02ea3.jpg";